<template>
    <div class="items-group">
        <div class="item-matter"
             @click.stop="submitMatter(matterItem)"
             @contextmenu.prevent.stop="submitOperate(matterItem, {}, $event)"
             v-for="matterItem in matterItems">
            <div class="row-matter-title">
                <div class="my-cursor"
                     :class="{
                    'icon-clock': matterItem.timeInfo.state <= 0,
                    'icon-clock-true': matterItem.timeInfo.state === 1,
                    'icon-clock-false': matterItem.timeInfo.state === 2
                     }"
                     :style="{backgroundColor: 'var(--color-priority-'+ matterItem.info.priority +')'}"
                     @click.stop="submitClock(matterItem, {})">
                </div>
                <div class="text-matter-title" :class="{'text-title-clocked': matterItem.timeInfo.state > 0}">
                    {{ matterItem.info.title }}
                </div>
            </div>
            <!--  日期 显示 待办 已打卡          -->
            <div class="row-matter-date" v-if="!matterItem.info.isWaiting || (matterItem.info.isWaiting && matterItem.timeInfo.state > 0)">
                <template v-if="matterItem.timeInfo.state <= 0">
                    <div class="text-matter-date" :style="{color: matterItem.timeInfo.state === -1 ? '#EA3323': '#666666'}">今天</div>
                    <div class="text-matter-time">{{ matterItem.timeInfo.timeText }}</div>
                </template>
                <template v-else>
                    <div class="text-clock-date">{{ matterItem.timeInfo.dateText }}</div>
                </template>
                <div class="icon-matter-remind" v-show="matterItem.info.iconIsRemind"></div>
                <div class="icon-matter-repeat" v-show="matterItem.info.iconIsRepeat"></div>
                <div class="my-cursor"
                     :class="[
                             {'icon-put-away': openChildArray.indexOf(matterItem.info.inventoryId) === -1},
                             {'icon-put-open': openChildArray.indexOf(matterItem.info.inventoryId) > -1}
                             ]"
                     @click.stop="setOpenChildArray(matterItem.info.inventoryId)"
                     v-if="matterItem.childArray.length > 0">
                </div>
            </div>
            <div class="row-matter-child"
                 @click.stop=""
                 v-if="matterItem.childArray.length > 0 && openChildArray.indexOf(matterItem.info.inventoryId) > -1">
                <div class="child-item"
                     @contextmenu.prevent.stop="submitOperate(matterItem, childItem, $event)"
                     v-for="childItem in matterItem.childArray">
                    <div class="row-child-title">
                        <div class="my-cursor"
                             :class="{
                            'icon-clock': childItem.timeInfo.state <= 0,
                            'icon-clock-true': childItem.timeInfo.state === 1,
                            'icon-clock-false': childItem.timeInfo.state === 2
                             }"
                             :style="{backgroundColor: 'var(--color-priority-'+ matterItem.info.priority +')'}"
                             @click.stop="submitClock(matterItem, childItem)">
                        </div>
                        <div class="text-child-title" :class="{'text-title-clocked': childItem.timeInfo.state > 0}">{{ childItem.info.title }}</div>
                    </div>
                    <div class="row-child-date" v-if="childItem.timeInfo.state > 0">
                        <div class="text-matter-date">{{ childItem.timeInfo.dateText }}</div>
                    </div>
                </div>
            </div>
        </div>
    </div>

</template>

<script>
import {mapMutations, mapState} from "vuex";

export default {
    name: "MatterGroup",
    data(){
        return {
        }
    },
    computed: {
        ...mapState("listModules", {
            openChildArray: state => state.openChildArray,
        })
    },
    props: {
        matterItems: {
            type: Array,
            default: () => [],
        }
    },
    methods: {
        ...mapMutations('listModules', ["setOpenChildArray"]),
        submitOperate: function(matterItem, childItem, e){
            this.$emit("operateEvent", {matterItem: matterItem, childItem: childItem, mouseX: e.x, mouseY: e.y});
        },
        submitClock: function(matterItem, childItem){
            this.$emit("clockEvent", {matterItem:matterItem, childItem: childItem})
        },
        submitMatter: function(matterItem){
            this.$emit("matterEvent", matterItem)
        },
    },
}
</script>

<style scoped>
div.items-group{
}
div.item-matter{
    padding: 0.16rem 0;
    border-bottom: 0.02rem dashed #000000;
    box-sizing: border-box;
}
div.row-matter-title {
    width: 100%;
    height: 0.25rem;
    box-sizing: border-box;
    margin-bottom: 0.04rem;
    display: flex;
    gap: 0.12rem;
}

div.icon-clock, div.icon-clock-true, div.icon-clock-false {
    width: 0.25rem;
    height: 0.25rem;
}

div.icon-clock {
    mask: url("../../../../assets/images/List/icon-clock.png") no-repeat;
    mask-size: 100%;
}

div.icon-clock-true {
    mask: url("../../../../assets/images/List/icon-clock-true.png") no-repeat;
    mask-size: 100%;
}

div.icon-clock-false {
    mask: url("../../../../assets/images/List/icon-clock-false.png") no-repeat;
    mask-size: cover;
}

div.text-matter-title, div.text-child-title{
    flex: 1;
    height: 0.25rem;
    font-family: PF-Regular, sans-serif;
    font-weight: bold;
    font-size: 0.18rem;
    color: #000000;
    line-height: 0.25rem;

    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
}
div.text-child-title{
    font-weight: 400;
}
div.row-matter-date, div.row-child-date{
    width: 100%;
    height: 0.21rem;
    padding-left: 0.36rem;
    box-sizing: border-box;

    font-family: PF-Regular, sans-serif;
    font-size: 0.15rem;
    color: #666666;
    line-height: 0.21rem;
    text-align: left;
}
div.text-matter-date, div.text-matter-time, div.text-clock-date{
    float: left;
    margin-right: 0.1rem;
}
div.icon-matter-remind, div.icon-matter-repeat{
    width: 0.14rem;
    height: 0.14rem;

    float: left;
    margin-right: 0.05rem;
    margin-top: 0.04rem;
}
div.icon-matter-remind{
    background: url("../../../../assets/images/List/icon-remind.png") no-repeat;
    background-size: cover;
}
div.icon-matter-repeat{
    background: url("../../../../assets/images/List/icon-repeat.png") no-repeat;
    background-size: cover;
}

div.icon-put-open,div.icon-put-away{
    width: 0.18rem;
    height: 0.18rem;
    float: right;
    margin-top: 0.02rem;
}
div.icon-put-open{
    background: url("../../../../assets/images/List/icon-put-open.png");
    background-size: cover;
}
div.icon-put-away{
    background: url("../../../../assets/images/List/icon-put-away.png");
    background-size: cover;
}

div.row-matter-child{
    width: 100%;
    padding-left: 0.36rem;
    box-sizing: border-box;
    padding-top: 0.13rem;
}
div.child-item{
    margin-top: 0.2rem;
}
div.child-item:nth-of-type(1){
    margin-top: 0;
}
div.row-child-title{
    height: 0.25rem;
    box-sizing: border-box;
    display: flex;
    gap: 0.12rem;
}

div.text-title-clocked{
    color: #999999;
    text-decoration-line: line-through;
}
</style>